import { CheckCircle, XCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface PortStatus {
  isAvailable: boolean
  conflictingProcess?: string | null
  suggestedAlternative?: number | null
}

interface PortStatusIndicatorProps {
  status: PortStatus
}

function PortAvailable(): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <span className="flex items-center gap-1 text-green-600 dark:text-green-400">
      <CheckCircle className="h-3 w-3" />
      {t('velociraptorSettings.available')}
    </span>
  )
}

function PortInUse({ status }: PortStatusIndicatorProps): React.ReactElement {
  const { t } = useTranslation('admin')
  const conflictSuffix = status.conflictingProcess ? ` by ${status.conflictingProcess}` : ''
  const alternative = status.suggestedAlternative
  return (
    <span className="flex items-center gap-1 text-red-600 dark:text-red-400">
      <XCircle className="h-3 w-3" />
      {t('velociraptorSettings.inUse')}
      {conflictSuffix}
      {alternative !== null && alternative !== undefined && (
        <span className="text-stone-500"> - try {String(alternative)}</span>
      )}
    </span>
  )
}

export function PortStatusIndicator({ status }: PortStatusIndicatorProps): React.ReactElement {
  return (
    <div className="mt-1 text-xs">
      {status.isAvailable ? <PortAvailable /> : <PortInUse status={status} />}
    </div>
  )
}
